var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SrSelect',{ref:"macros",staticClass:"macros",attrs:{"items":_vm.macros,"item-text":"name","item-value":"id","label":"Macros","return-object":"","searchable":"","required":""},on:{"change":_vm.handleMacroSelected},model:{value:(_vm.selectedMacro),callback:function ($$v) {_vm.selectedMacro=$$v},expression:"selectedMacro"}})
}
var staticRenderFns = []

export { render, staticRenderFns }